import Word from '../functions/wordClass';
export default function check(word) {
    let w = new Word(word);
    if (Object.keys(w.lettersObject).length < 3) {
        return [false, "less than 3 distinct letters"];
    }
    if (w.length > 13) {
        return [false, "more than 13 letters"];
    }
    if (!word.match(/^[a-zA-Z]+$/)) {
        return [false, "invalid characters"];
    }
    return [true];
}
